export const AlignEnum = {
  Left: 'left',
  Right: 'right'
} as const

export const RepresentationEnum = {
  LogoArea: 'logo_area',
  Icon: 'icon',
  Des: 'des',
  ActionButton: 'action_button',
  Component: 'component',
  Link: 'link',
  Breadcrumbs: 'breadcrumbs',
  NavigationMenu: 'navigation_menu',
  ManagementDashboard: 'management_dashboard'
} as const
